module.exports = __webpack_public_path__ + "static/media/amazonevent.df7715d0.jpeg";